import Api, { make, Response } from 'src/services/api'

import { AddressCountry } from 'src/types'

type Data = {
  countries: AddressCountry[]
}

type GetAllProps = {
  page?: number
  queryName: string
}

export const PAGE_SIZE = 10

async function getAll({
  queryName,
  page
}: GetAllProps): Promise<Response<AddressCountry[]>> {
  return make<Data, AddressCountry[]>({
    axiosCall: Api.get(
      `countries?page_size=${PAGE_SIZE}&page=${page || 1}&country=${queryName}`
    ),
    transformData: data => data.countries
  })
}

export default { getAll }
